import React from "react";
import { Button, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  dbfIntegrations,
  getDarwinBox,
  kekaIntegrations,
  removeIntegrationsData,
  setEmployeeId,
  setEmployeeNo,
  setRefreshToken,
  setTelegramId,
  setTelegramToken,
  setUser,
  setWhatsappNumber,
  setWhatsappCountryCode,
  telegramIntegrations,
  whatsappIntegration,
  getIntegrationsData,
} from "../../redux/slices/integrationSlice";
import {
  setIsActivatePopup,
  setIsEditpopup,
  setIsPopUpShow,
} from "../../redux/slices/popUpSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_ROUTES } from "../../utils/constants";
import AppSecureStorage from "../../services/secureStorage";
import { update_user } from "../../redux/slices/userManagementSlice";
import { encryptData } from "../../utils/helpers";
import { toast } from "react-toastify";

const storage = new AppSecureStorage();

export const DialogBox = ({
  renderUi = () => {},
  onSubmit,
  isFooter,
  customFooter = () => {},
  onClose = () => {},
  width,
  disableSubmit = false,
  isSelfbestIntegrationVerified = false,
  setIsSelfbestIntegrationVerified = () => {},
  loader = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    refreshToken,
    employeeId,
    employeeNo,
    user: { email, password },
    telegramId,
    whatsappNumber,
    whatsappCountryCode,
  } = useSelector((state) => state.integrationReducer);
  const {
    isPopUpShow,
    actionName,
    popUpTitle,
    closeBtnName,
    submitBtnName,
    isEditpopup,
  } = useSelector((state) => state.popUpRedducer);
  const {
    page,
    filterValue,
    limit,
    searchInput,
    selectedRole,
    sortConfig,
    selectedUserRoleId,
  } = useSelector((state) => state.globalReducer);

  const handleOk = () => {
    dispatch(setIsPopUpShow(false));
    dispatch(setRefreshToken(""));
    dispatch(setUser({ email: "", password: "" }));
    dispatch(setTelegramId(""));
    dispatch(setEmployeeId(""));
    dispatch(setEmployeeNo(""));
    dispatch(setTelegramToken(""));
    dispatch(setWhatsappNumber(""));
    dispatch(setIsEditpopup(false));
    dispatch(setWhatsappCountryCode(null));
    setIsSelfbestIntegrationVerified(false);
    onClose();
  };

  const handleIntegrations = (integrationAction) => {
    switch (integrationAction) {
      case "keka":
        dispatch(kekaIntegrations({ body: { refreshToken }, navigate }));
        break;
      case "darwinbox":
        dispatch(
          getDarwinBox({
            employeeId,
            body: { employee_id: employeeId, employee_no: employeeNo },
            navigate,
          }),
        );
        break;
      case "whatsapp":
        dispatch(
          whatsappIntegration({
            body: {
              whatsappContactNumber: whatsappNumber,
              countryCode: whatsappCountryCode,
            },
            navigate,
          }),
        );
        break;
      case "telegram":
        dispatch(telegramIntegrations({ body: { telegramId }, navigate }));
        break;
      default:
        break;
    }
    dispatch(setIsPopUpShow(false));
  };

  const handleSubmit = () => {
    switch (actionName) {
      case "User role change":
        dispatch(
          update_user({
            id: selectedUserRoleId,
            data: { role: selectedRole },
            navigate: navigate,
            page: page,
            limit: limit,
            filterValue: filterValue.toLowerCase(),
            searchQuery: searchInput,
            sortKey: sortConfig.key,
            sortDirection: sortConfig.direction,
          }),
        );
        dispatch(setIsPopUpShow(false));
        break;
      case "User Role":
        dispatch(setIsActivatePopup(true));
        dispatch(setIsPopUpShow(false));
        break;
      case "activate":
        // Check if it's a special app that needs custom handling
        const appName = popUpTitle?.toLowerCase();
        if (
          appName === "keka" ||
          appName === "darwinbox" ||
          appName === "whatsapp" ||
          appName === "telegram" ||
          appName === "whats app"
        ) {
          handleIntegrations(popUpTitle);
        } else {
          // For other apps (Gmail, Google Calendar, etc.), use the onSubmit handler
          onSubmit();
        }
        break;
      case "deactivate":
        dispatch(removeIntegrationsData({ name: popUpTitle, navigate }));
        dispatch(setIsPopUpShow(false));
        break;
      case "google_calendar":
      case "jira":
      case "salesforce":
      case "outlook":
        handleExternalIntegrations();
        break;
      case "telegram":
        onSubmit();
        break;
      case "WhatsAppSettings":
        onSubmit();
        break;
      case "WhatsApp":
        onSubmit();
        break;
      default:
        break;
    }
  };

  const handleExternalIntegrations = () => {
    const token = storage.get("token");

    const apiUrl = `${API_ROUTES.BASE_URL}integration/${
      actionName === "google_calendar"
        ? "google-calendar"
        : actionName === "outlook"
          ? "outlook/login"
          : actionName
    }?authorization=Bearer ${token}`;

    if (
      actionName === "jira" ||
      actionName === "google_calendar" ||
      actionName === "salesforce"
    ) {
      window.location.href = apiUrl;
      return;
    }

    if (actionName === "outlook") {
      axios
        .get(apiUrl, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => {
          const redirectUrl =
            response?.data?.url || response?.data?.redirectUrl;
          if (redirectUrl) {
            window.location.href = redirectUrl;
          } else {
            console.error(
              "Outlook integration endpoint did not return a redirect URL.",
              response?.data,
            );
          }
        })
        .catch((error) => {
          console.error("Outlook integration redirect failed:", error);
        });
      return;
    }

    axios
      .get(apiUrl, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => dispatch(setIsPopUpShow(false)))
      .catch(() => {});
  };

  const handleSelfBestIntegration = async () => {
    const integrationsData = await dispatch(
      getIntegrationsData(navigate),
    ).unwrap();
    const selfBestIntegration = integrationsData.find(
      (integration) => integration.name.toLowerCase() === "selfbest",
    );
    if (selfBestIntegration.isActivated) {
      toast.success(`Integration with SelfBest activated successfully.`, {
        toastId: "integration-success",
      });
      setIsSelfbestIntegrationVerified(false);
      setTimeout(() => {
        handleOk();
      }, 1000);
    } else {
      toast.error(
        `Integration with SelfBest is not completed yet. Please complete it in SelfBest and try again`,
        {
          toastId: "integration-error",
        },
      );
    }
  };

  const isSelfBestPopup = popUpTitle?.toLowerCase() === "selfbest";
  const renderFooter = () => (
    <div className="button-groups">
      <Button onClick={handleOk}>{closeBtnName}</Button>
      {isSelfBestPopup ? (
        <div>
          <Button
            className="submit-button"
            type ="primary"
            loading={loader}
            onClick={handleSelfBestIntegration}
            disabled={!isSelfbestIntegrationVerified}
          >
            Verify Integration
          </Button>
        </div>
      ) : ["google_calendar", "jira", "salesforce"].includes(actionName) ? (
        <a
          href={`${API_ROUTES.BASE_URL}integration/${
            actionName === "google_calendar" ? "google-calendar" : actionName
          }?authorization=Bearer ${storage.get("token")}`}
        >
          <Button loading={loader} className="submit-button">
            {submitBtnName}
          </Button>
        </a>
      ) : (
        <Button
          className="submit-button"
          onClick={handleSubmit}
          loading={loader}
          disabled={disableSubmit}
        >
          {submitBtnName}
        </Button>
      )}
    </div>
  );
  let capitalizedTitle;

  if (popUpTitle === "google_calendar") {
    capitalizedTitle = "Google Calendar";
  } else if (popUpTitle.toLowerCase() === "dbf") {
    capitalizedTitle = "DBF";
  } else if (popUpTitle.toLowerCase() === "selfbest") {
    capitalizedTitle = "SelfBest";
  } else {
    capitalizedTitle = popUpTitle.charAt(0).toUpperCase() + popUpTitle.slice(1);
  }

  return (
    <Modal
      className="modal-container"
      title={capitalizedTitle}
      open={isEditpopup ? isEditpopup : isPopUpShow}
      onOk={handleOk}
      onCancel={handleOk}
      footer={isFooter ? customFooter() : renderFooter()}
      centered
      width={width}
    >
      {renderUi()}
    </Modal>
  );
};
